<template>
  <div class="ma-10">
    <v-dialog
      v-model="showCategoryPopup"
      max-width="400"
      persistent
    >
      <v-card>
        <v-card-title class="modal-title">
          Pilih Kategori
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item
              v-for="category in listCategory"
              :key="category.value"
              @click="selectCategory(category.value)"
              :class="{ 'selected-category': filter.category === category.value }"
            >
              <v-list-item-title>{{ category.name }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#3b54d9"
            text
            @click="clearCategory"
          >
            Clear Filter
          </v-btn>
          <v-btn
            color="#3b54d9"
            text
            @click="showCategoryPopup = false"
          >
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <Loading v-if="isLoading" />
    <Popup
      :message="message"
      v-if="isPopup"
      @close="() => (isPopup = false)"
    />
    <div class="top-container-box">
      <h1>Corporate Training</h1>
      <div>
        <Button
          icon="+"
          outline
          name="Create CT"
          style="background-color: #3b54d9; color: #ffffff; width: 160px"
          @click="() => $router.push('/corporate-training/new')"
        />
      </div>
    </div>
    <v-row>
      <v-col cols="6">
        <div class="action-head">
          <div class="f-search">
            <div>
              <v-text-field
                v-model="filter.title"
                type="text"
                class="f-input"
                placeholder="Search..."
                clearable
                dense
                flat
                solo
                style="
                  padding-top: 5px;
                  padding-left: 5px;
                  width: 448px;
                  border-radius: 14px;
                "
                @input="() => getCorporateTraining()"
              ></v-text-field>
            </div>
            <div class="f-search-ic">
              <img
                src="/img/icons/search.png"
                style="width: 100%"
                alt="Search Ic"
              />
            </div>
          </div>
          <v-btn
            class="ml-4"
            color="#3b54d9"
            style="color: #ffffff; border-radius: 10px"
            @click="showCategoryPopup = true"
          >
            Filter Kategori
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <NewTable
      :headers="headers"
      :rows="corporate_trainings"
      :currentPage="currentPage"
      :totalPages="total"
      :totalData="totalData"
      :customColumns="customColumns"
      :perPage="perPage"
      :onEdit="editItem"
      :onView="watchItem"
      :onDelete="onDelete"
      :onPageChange="getCorporateTraining"
    />
  </div>
</template>

<script>
import Button from "@/components/Button.vue";
import Loading from "@/components/ilustration/Loading.vue";
import Popup from "@/components/others/Popup.vue";
import NewTable from "@/components/Tabel.vue";
import getAuthentification from "@/utils/badrequest.js";
import moment from "moment";

export default {
  name: "CorporateTraining",
  components: {
    Button,
    Loading,
    Popup,
    NewTable,

  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      total: 0,
      perPage: 10,
      totalData: 0,
      message: "",
      isPopup: false,
      filter: {
        title: "",
        sort_by: "desc",
        category: "",
      },
      showCategoryPopup: false,
      listCategory: [
            { name: "General", value: "GENERAL" },
            { name: "Certified", value: "CERTIFIED" },
          ],
      headers: [
        {
          text: "TITLE",
          field: "title",
          width: 200,
        },
        {
          text: "CATEGORY",
          field: "category",
          width: 150,
        },
        {
          text: "CREATED AT",
          field: "created_at",
          width: 150,
        },
      ],
      corporate_trainings: [],
      customColumns: [
        {
          field: "created_at",
          render: (row) => {
            return moment(String(row.created_at)).format("DD-MMM-YYYY");
          },
        },
      ],
    };
  },
  methods: {
    async getCorporateTraining(page) {
      if (!page) page = this.currentPage;
      else this.currentPage = page;

      this.isLoading = true;
      try {
        const response = await this.$crm_http.get(
          `/v1/corporate-training?page=${page}&per_page=${this.perPage}&sort_by=${this.filter.sort_by}&category=${this.filter.category || ""}&title=${this.filter.title || ""}`
        );
        const res = response.data.data.corporate_trainings || []
        this.corporate_trainings = res.map(
          (item) => ({
            id: item.id,
            title: item.title,
            category: item.category,
            created_at: item.created_at,
          })
        );
        const t = parseInt(response.data.data.total);
        this.total = Math.ceil(t / this.perPage) || 1;
        this.totalData = response.data.data.total;
        if (this.currentPage > this.total) {
          this.currentPage = this.total;
          this.getCorporateTraining();
        }
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to load data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    watchItem(id) {
      this.$router.push("/corporate-training/watch/" + id);
    },
    editItem(id) {
      this.$router.push("/corporate-training/edit/" + id);
    },
    async onDelete(id) {
      this.isLoading = true;
      try {
        await this.$crm_http.delete("/v1/corporate-training/" + id);
        this.getCorporateTraining();
      } catch (err) {
        this.message = err.response?.data?.data || "Failed to delete data.";
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    updateIsFilterActive() {
      this.isFilterActive = !(
        this.filter.sort_by === "desc" &&
        !this.filter.name &&
        !this.filter.category
      );
    },
    selectCategory(value) {
      this.filter.category = value;
      this.showCategoryPopup = false;
      this.getCorporateTraining();
      this.updateIsFilterActive();
    },
    clearCategory() {
      this.filter.category = "";
      this.showCategoryPopup = false;
      this.getCorporateTraining();
      this.updateIsFilterActive();
    },
  },
  beforeCreate() {
    getAuthentification();
  },
  mounted() {
    this.getCorporateTraining();
  },
};
</script>

<style scoped>
.action-head {
  margin-top: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.f-search {
  border: 1px solid #d3d6e1;
  width: 100%;
  height: 48px;
  gap: 10px;
  display: flex;
  border-radius: 10px;
  background-color: white;
}
.f-search-ic {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  margin-right: 18px;
}
.f-input {
  width: 86%;
  background: transparent;
  border: none;
}
.f-input:focus {
  background: transparent;
  border: none;
  outline-width: 0;
}
.top-container-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.count-data {
  position: relative;
  top: -60px;
  width: 30%;
}
.no-pagination {
  margin-top: 20px;
  margin-left: 5px;
}
.selected-category {
  background-color: #e3f2fd;
  color: #3b54d9;
}
</style>